import { __rest } from "tslib";
import { generateInputFieldBase } from '../InputField/index.shell';
import { forwardRef } from 'react';
import '@getgo/chameleon-web/components/TextArea/register';
export const TextArea = forwardRef((_a, ref) => {
    var { implicitSubmission } = _a, otherProps = __rest(_a, ["implicitSubmission"]);
    return generateInputFieldBase('chameleon-text-area', Object.assign({ 'implicit-submission': implicitSubmission }, otherProps), ref);
});
